/* eslint-disable no-console */
/* eslint-disable max-len */
import { trackEvent } from '../../../../utils/dtmHelpers'

const userDigitalData = window?.parent?.digitalData.user
// get conviva metadata
export const getProgrammeMetadata = (content) => {
  const broadcastDate = content.schedule && content.schedule.startTime
  const isShortform = content?.video?.videoType === 'shortform'
  const convivaMetadata = {
    'c3.cm.contentType': isShortform ? 'vc11' : 'vc12',
    'c3.cm.channel': 'Unknown',
    'c3.cm.seriesName': content.programme?.name || 'Unknown Program',
    'c3.cm.id': content?.matId || 'matID_not_set',
    'c3.cm.showTitle': content?.title || 'No title available',
    'c3.cm.genreList': content?.programme?.subGenre || 'N/A',
    'c3.cm.genre': content?.programme?.genre || 'N/A',
    [window?.Conviva?.Constants?.ASSET_NAME]: content?.guid || 'Unknown Program',
    [window?.Conviva?.Constants.PLAYER_NAME]: 'player',
    [window?.Conviva?.Constants?.APPLICATION_VERSION]: '1.1.0',
    [window?.Conviva?.Constants.IS_LIVE]: window?.Conviva?.Constants.StreamType.VOD,
    [window?.Conviva?.Constants.VIEWER_ID]: userDigitalData.userId,
    broadcastRegion: userDigitalData.broadcastRegion,
    user_subs_status: userDigitalData.subscriptionStatus,
    broadcast_date: broadcastDate,
    sub_genre: content.programme?.subGenre,
  }
  return convivaMetadata
}

export const getPlayerInfo = () => {
  const playerInfo = {
    [window?.Conviva?.Constants.DeviceMetadata.TYPE]: window?.Conviva?.Constants.DeviceType.DESKTOP,
    [window?.Conviva?.Constants.DeviceMetadata.CATEGORY]: window?.Conviva?.Constants.DeviceCategory.WEB,
  }
  return playerInfo
}

export const trackStandardEvents = (eventName, results) => {
  trackEvent(eventName, {
    startTime: results?.startTime,
    endTime: results?.endTime,
    broadcast_region: results?.stream || 'unknown',
    user_subs_status: userDigitalData.subscriptionStatus,
    content: results?.programmeGuid,
    mat_id: results?.matId,
    custom_content_type: 'vc13',
    video_name: results?.programmeName,
    content_channel: results?.channel,
    timestamp: Math.floor(new Date().getTime() / 1000),
    site: 'player',
  })
}

export const initialiseAdAnalytics = () => {
  if (!window.ConvivaAdAnalytics) {
    if (!window.ConvivaVideoAnalytics) {
      console.error('Advert analytics object cannot be initialised without video analytics object.')
      return
    }
    window.ConvivaAdAnalytics = window.Conviva.Analytics.buildAdAnalytics(window.ConvivaVideoAnalytics) // For SSAI, we can use videoAnalytics directly
  }
}

const generateConvivaAdInfo = (adDetails, breakType) => ({
  [window?.Conviva?.Constants.ASSET_NAME]: adDetails?.title,
  [window?.Conviva?.Constants.IS_LIVE]: window?.Conviva?.Constants.StreamType.VOD,
  'c3.ad.id': adDetails?.id,
  'c3.ad.system': adDetails?.system,
  'c3.ad.position': breakType,
  'c3.ad.sequence': (adDetails?.index).toString(),
})

export const convivaAdHandlers = {
  handlePodStart: () => {
    // if (!window.ConvivaVideoAnalytics) {
    //   console.error('videoAnalytics is not initialised')
    //   return
    // }
    //   window.ConvivaVideoAnalytics.reportAdBreakStarted(
    //     Conviva.Constants.AdType.SERVER_SIDE,
    //     Conviva.Constants.AdPlayer.CONTENT,
    //   )
  },
  handleAdBreakEnd: () => {
    if (window.ConvivaVideoAnalytics) {
      window.ConvivaVideoAnalytics.reportAdBreakEnded()
    } else {
      console.error('videoAnalytics is not initialised')
    }
  },
  handleAdLoaded: (adDetails, breakType) => {
    if (window.ConvivaAdAnalytics) {
      const adInfo = generateConvivaAdInfo(adDetails, breakType)
      window.ConvivaAdAnalytics.reportAdLoaded(adInfo)
    } else {
      console.error('adAnalytics is not initialised')
    }
  },
  handleAdStarted: (adDetails, breakType) => {
    if (window.ConvivaAdAnalytics) {
      const adInfo = generateConvivaAdInfo(adDetails, breakType)
      window.ConvivaAdAnalytics.reportAdStarted(adInfo)
      window.ConvivaAdAnalytics.reportAdMetric(window.Conviva.Constants.Playback.PLAYER_STATE, window.Conviva.Constants.PlayerState.PLAYING)
    } else {
      console.error('adAnalytics is not initialised')
    }
  },
  handleAdEnded: () => {
    if (window.ConvivaAdAnalytics) {
      window.ConvivaAdAnalytics.reportAdEnded()
    } else {
      console.error('adAnalytics is not initialised')
    }
  },
  handleAdError: (errorMessage, adDetails) => {
    if (window.ConvivaAdAnalytics) {
      const adInfo = generateConvivaAdInfo(adDetails)
      window.ConvivaAdAnalytics.reportAdFailed(errorMessage, adInfo)
    } else {
      console.error('adAnalytics is not initialised')
    }
  },
  handleAdSkipped: () => {
    if (window.ConvivaAdAnalytics) {
      window.ConvivaAdAnalytics.reportAdSkipped()
    } else {
      console.error('adAnalytics is not initialised')
    }
  },
}

export function getBreakType(name) {
  switch (name) {
    case 'start': return 'PREROLL'
    case 'end': return 'POSTROLL'
    default: return 'MIDROLL'
  }
}
